var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-op-log-container" },
    [
      _c(
        "div",
        { staticClass: "code-staff-search" },
        [
          _c("el-input", {
            staticStyle: { width: "180px", "margin-right": "10px" },
            attrs: {
              placeholder: "档案名/昵称/手机号/卡号",
              "suffix-icon": "el-icon-search",
              size: "mini",
              clearable: ""
            },
            on: { blur: _vm.searchFn, clear: _vm.searchFn },
            model: {
              value: _vm.getFileOpLogListParams.term,
              callback: function($$v) {
                _vm.$set(_vm.getFileOpLogListParams, "term", $$v)
              },
              expression: "getFileOpLogListParams.term"
            }
          }),
          _c(
            "el-tag",
            {
              staticClass: "select-stafft-wrap",
              attrs: {
                title: "选择员工",
                closable: _vm.searchMenNames.length === 0 ? false : true,
                type: "medium",
                effect: "plain"
              },
              on: {
                close: _vm.searchCloseTag,
                click: function($event) {
                  return _vm.clickAddMember()
                }
              }
            },
            [
              _vm.searchMenNames.length === 0
                ? _c("span", [_vm._v("选择员工")])
                : _vm._e(),
              _vm._l(_vm.searchMenNames, function(item, index) {
                return _c("span", { key: index, staticClass: "staff-names" }, [
                  _vm._v(_vm._s(item.name)),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.searchMenNames.length > 1 &&
                            index != _vm.searchMenNames.length - 1,
                          expression:
                            "\n            searchMenNames.length > 1 && index != searchMenNames.length - 1\n          "
                        }
                      ]
                    },
                    [_vm._v(",")]
                  )
                ])
              })
            ],
            2
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "140px", "margin-right": "10px" },
              attrs: { placeholder: "操作类型", size: "mini" },
              on: { change: _vm.selectBindStatus },
              model: {
                value: _vm.getFileOpLogListParams.bindType,
                callback: function($$v) {
                  _vm.$set(_vm.getFileOpLogListParams, "bindType", $$v)
                },
                expression: "getFileOpLogListParams.bindType"
              }
            },
            _vm._l(_vm.operationOptions, function(item) {
              return _c("el-option", {
                key: item.bindStatus,
                attrs: { label: item.label, value: item.bindStatus }
              })
            }),
            1
          ),
          _c("el-date-picker", {
            staticStyle: { width: "240px" },
            attrs: {
              size: "mini",
              editable: false,
              type: "datetimerange",
              "value-format": "yyyy-MM-dd HH:mm:ss",
              "default-time": ["00:00:00", "23:59:59"],
              "range-separator": "~",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              clearable: ""
            },
            on: { change: _vm.selectTime },
            model: {
              value: _vm.getFileOpLogListParams.time,
              callback: function($$v) {
                _vm.$set(_vm.getFileOpLogListParams, "time", $$v)
              },
              expression: "getFileOpLogListParams.time"
            }
          })
        ],
        1
      ),
      [
        _c(
          "el-table",
          {
            ref: "cusChatTable",
            staticStyle: { "font-size": "13px" },
            attrs: {
              size: "small",
              data: _vm.tableData,
              fit: "",
              "highlight-current-row": "",
              align: "center",
              "header-cell-style": { background: "#F9F9F9" },
              height: "calc(100vh - 238px)"
            }
          },
          [
            _c("el-table-column", {
              attrs: { label: "客户", "min-width": "250" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _vm.getFileOpLogListParams.bindType == 1
                        ? _c("div", [_vm._v(" 全部客户 ")])
                        : _c(
                            "div",
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticStyle: { padding: "0" },
                                      attrs: { span: 30 }
                                    },
                                    [
                                      _c("el-avatar", {
                                        attrs: {
                                          size: "medium",
                                          shape: "square",
                                          src: scope.row.avatar
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("el-col", { attrs: { span: 70 } }, [
                                    scope.row.ctmName != null
                                      ? _c(
                                          "div",
                                          { staticStyle: { color: "black" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.ctmName) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticStyle: { color: "black" } },
                                          [_vm._v("无绑定职称")]
                                        ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          color: "#a09f9fc9",
                                          "font-size": "12px"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(scope.row.nickName)
                                        ),
                                        scope.row.type == 1
                                          ? _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "rgb(70, 189, 10)"
                                                }
                                              },
                                              [_vm._v(" @微信")]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "rgb(8, 168, 231)"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " @" +
                                                    _vm._s(scope.row.corpName)
                                                )
                                              ]
                                            )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: { prop: "ctmCode", label: "卡号", "min-width": "200" }
            }),
            _c("el-table-column", {
              attrs: { label: "操作类型", "min-width": "150" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      _c("div", [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              scope.row.bindType == 1 ? "档案绑定" : "档案解绑"
                            )
                          )
                        ])
                      ])
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: { label: "档案详情", "min-width": "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(scope) {
                    return [
                      true
                        ? _c(
                            "el-button",
                            {
                              staticClass: "table-button",
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.handleDetail(
                                    scope.$index,
                                    scope.row
                                  )
                                }
                              }
                            },
                            [_vm._v("查看")]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _c("el-table-column", {
              attrs: {
                prop: "applyName",
                label: "操作员工",
                "min-width": "150"
              }
            }),
            _c("el-table-column", {
              attrs: {
                prop: "createTime",
                label: "操作时间",
                "min-width": "200"
              }
            })
          ],
          1
        )
      ],
      _c("Pagination", {
        attrs: { childMsg: _vm.pageparm, pageSizes: _vm.pageSizes },
        on: { callBack: _vm.callBack }
      }),
      _c("StaffTree", {
        attrs: {
          title: "选择成员",
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.currentSelectMember
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      }),
      _c("FileDetai", {
        attrs: { visiAble: _vm.detailVisiAble, detailItem: _vm.detailParams },
        on: { closeDetail: _vm.closeDetail }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }